<template>
  <i-dropdown>
    <template v-slot:trigger="{toggle, attrs}">
      <button
        class="i-button btn i-simple-btn"
        @click="toggle"
        v-bind="attrs">
          <i class="fas fa-star fa5" aria-hidden="true"></i>
          <span>{{ LANG.filters }}</span>
          <i class="fas fa-caret-down pl1" aria-hidden="true"></i>
      </button>
    </template>
    <template v-slot:default="{close}">
      <ul class="dropdown-menu i-dropdown-menu block pull-right overflow-y-auto" role="menu">
        <li v-for="{ name } in savedFilters"
          :key="name"
          :aria-label="name"
        >
          <a href="#"
            :title="name"
            @click.prevent="() => { loadSavedFilter({ name }); close(); }"
          >
            {{ name }}
          </a>
        </li>

        <li class="border-t border-solid border-gray"
          :aria-label="LANG.manageFilters">
          <a target='_blank'
            :href="uri('/document/saved_filters')"
            :title="LANG.manageFilters"
            :aria-label="newWindowLabel"
            >{{LANG.manageFilters}}
          </a>
        </li>
      </ul>
    </template>
  </i-dropdown>
</template>

<script>
import globals from '@/globals';
import { mapState } from 'vuex';
import { mapBrowserState, mapBrowserMutations } from '@/store';

const { uri } = globals.I.Util;

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['LANG']),
    ...mapBrowserState([
      'savedFilters',
    ]),
    newWindowLabel() {
      return `${this.LANG.manageFilters} ${this.LANG.opensBlank}`;
    },
  },
  methods: {
    uri,
    ...mapBrowserMutations([
      'loadSavedFilter',
    ]),
  },
};
</script>

<style scoped lang='scss'>
.i-dropdown-menu {
  max-height: 480px;
  width: 200px;
}
</style>
